import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldSevenSegStr } from '@/(routers)/boards/editor/block/definitions/fields/fieldSevenSegStr';

defineBlock({
    type: 'string_seven_seg',
    colour: CATEGORIES.display.color,
    tooltip: '7SEGの1桁分の文字',
    output: 'SevenSegChar',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    name: 'CHAR',
                    instance: () => new FieldSevenSegStr(' '),
                },
            ],
        },
    ],
    onInit(this: Blockly.Block) {
        this.setOutputShape(3);
    },
});
